<template>
<div :class="['fit-toast-wrap',{show : !isHidden}]" v-on:touchmove.prevent >
    <div class="dock flex-center">
        <div class="content">
            <div class="dock flex-center">
                <div>
                    <img class="icon" v-if="image" :src="image"></img>
                    <i class="icon" :class="iconClass" v-else ></i>
                    <div class="txt" v-html="toastTitle"></div>
                    <div class="loading"></div>
                </div>
            </div>
        </div>
    </div>
</div>

</template>
<script>
import base from '../../mixins/base.js';
const fitToast = {
  name: 'fit-toast',
  mixins: [base],
  data() {
    return {
      title: '',
      icon: 'none',
      image: '',
      duration: 0,
      isHidden: true,
    };
  },
  computed: {
    iconClass() {
      return this.icon ? `icon-${this.icon}` : '';
    },
    toastTitle() {
      if (!this.iconSrc) {
        return this.title;
      }
      if (this.title && this.title.length > 7) {
        return this.title.substring(0, 7);
      }
      return this.title;
    },
  },
  methods: {
    show(args) {
      const options = args ? args : {};
      this.image = '';
      this.hide();
      this.$nextTick(function () {
        [
          'title',
          'icon',
          'image',
          'duration',
        ].forEach((prop) => {
          if (options.hasOwnProperty(prop) && typeof this[prop] === typeof options[prop]) {
            this[prop] = options[prop];
          }
        });
        this.isHidden = false;
        if (this.duration) {
          this.timer = window.setTimeout(() => {
            this.isHidden = true;
          }, this.duration);
        }
      });
    },
    hide() {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
        this.duration = 0;
      }
      this.isHidden = true;
    },
  },
};
export default fitToast;
</script>
<style lang="less" scoped>
.flex-center {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
/**
 * toast样式
 */
.fit-toast-wrap {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.2);
  text-align: center;
  z-index: 99999;
}

.fit-toast-wrap.show {
  display: block;
}

.fit-toast-wrap .dock {
  width: 100%;
  height: 100%;
}

.fit-toast-wrap .content {
  margin: 0 auto;
  width: 120px;
  height: 120px;
  overflow: hide;
  -webkit-box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  overflow: hidden;
  color: #ffffff;
  background-color: rgba(17, 17, 17, 0.7);
}

.fit-toast-wrap .icon {
  display: inline-block;
  height: 36px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  -moz-background-size: 100%;
}

.fit-toast-wrap .txt {
  margin-top: 16px;
  font-size: 13px;
  line-height: 19px;
}

.fit-toast-wrap .icon-loading {
  width: 36px;
  background-image: url('../../assets/image/loading.gif');

  &::before {
    content: '' !important;
  }
}

.fit-toast-wrap .icon-success {
  width: 59px;
  background-image: url('../../assets/image/success.png');
  background-size: 80%;
  -moz-background-size: 80%;

  &::before {
    content: '' !important;
  }
}

.fit-toast-wrap .icon-fail {
  height: 40px;
  width: 40px;
  margin: 0 auto;
  background: url(data:image/png;base64,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)
    no-repeat 0 0;
  -webkit-background-size: 100% 100%;
  background-size: 100% 100%;

  &::before {
    content: '' !important;
  }
}
</style>
